import React, { useState, useEffect } from 'react';
import { createBetRecord } from '../../../api/betsApi';
import normalizeString from '../../../utils/normalize';

export const BalotoForm = ({ formInfo, valuesAllowed }) => {
  const [serial, setSerial] = useState('');
  const [results, setResults] = useState({});
  const [superResult, setSuperResult] = useState('');
  const [resultError, setResultError] = useState({});
  const [loading, setLoading] = useState(false);
  const [blockOnsend, setblockOnsend] = useState(false);
  const order = ['Primera', 'Segunda', 'Tercera', 'Cuarta', 'Quinta'];
  const actualDate = new Date().toISOString().split('T')[0];

  useEffect(()=>{
    formInfo?.result?.forEach((_,index)=>{
      setResults((prev) => ({
        ...prev,
        [`Resultado Balota ${index}`]: '',
      }));
    });
  },[formInfo?.result]);

  const processResult = (result) =>{
    if(formInfo?.colors){
      return String(result);
    }
    return String(result).padStart(2, '0');;
  };

  const handleSubmit = async (e) =>{
    e.preventDefault();
    const superResultNumber = Number(superResult);
    let formError = false;
    for(const name in results){
      const value = results[name];
      const resultNumber = Number(value);
      if(resultNumber < valuesAllowed.result[0] || resultNumber > valuesAllowed.result[1]){
        setResultError((prev) => ({
          ...prev,
          [name]: `El número debe tener un valor entre ${processResult(valuesAllowed.result[0])} y ${processResult(valuesAllowed.result[1])}`,
        }));
        formError = true;
      }else{
        setResultError((prev) => {
          const { [name]: _, ...everything } = prev;
          return everything;
        });
      }
    }
    if(formInfo.superResult && ( superResultNumber < valuesAllowed.superResult[0] || superResultNumber > valuesAllowed.superResult[1])){
      setResultError((prev) => ({
        ...prev,
        'Resultado Super Balota': `El super número debe tener un valor entre ${processResult(valuesAllowed.superResult[0])} y ${processResult(valuesAllowed.superResult[1])}`,
      }));
      formError = true;
    }else{
      setResultError((prev) => {
        const { 'Resultado Super Balota': _, ...everything } = prev;
        return everything;
      });
    }
    if(!formError){
      try {
        const colorInfo = formInfo?.colors?.map((_, index) => (e.target.elements[`Color balota ${index}`]?.value));
        const betName = normalizeString(formInfo.name);
        const betInfo = {
          betName: betName,
          serialNumber: Number(serial),
          result: Object.values(results),
          superResult: superResult,
          colorResult: colorInfo,
          date: e.target.elements[`Fecha del sorteo ${formInfo?.name}`]?.value
        }
        await createBetRecord(betName, betInfo);
        setblockOnsend(true);
        alert('Registro creado con éxito');
      } catch (error) {
        setblockOnsend(false);
        alert('Error al crear el registro');
      } finally {
        setLoading(false);
      }
    }
  };

  const handleSerialChange = (e) =>{
    const numbers = e.target.value.replace(/\D/g, '').slice(0, 4);
    setSerial(numbers);
  };
  const handleResultChange = (e) =>{
    const { name, value } = e.target;
    const numbers = value.replace(/\D/g, '').slice(0, 2);

    setResults((prev) => ({
      ...prev,
      [name]: numbers,
    }));
  };
  const handleSuperResultChange = (e) =>{
    const numbers = e.target.value.replace(/\D/g, '').slice(0, 2);
    setSuperResult(numbers);
  };
  const handleResultBlur = (e) => {
    const { name, value } = e.target;
    const resultNumber = Number(value);

    if(resultNumber < valuesAllowed.result[0] || resultNumber > valuesAllowed.result[1]){
      setResultError((prev) => ({
        ...prev,
        [name]: `El número debe tener un valor entre ${processResult(valuesAllowed.result[0])} y ${processResult(valuesAllowed.result[1])}`,
      }));
    }else{
      setResultError((prev) => {
        const { [name]: _, ...everything } = prev;
        return everything;
      });
    }

    setResults((prev) => ({
      ...prev,
      [name]: processResult(value),
    }));
  };
  const handleSuperResultBlur = (e) => {
    const { name, value } = e.target;
    const resultNumber = Number(value);
    if(valuesAllowed.superResult && ( resultNumber < valuesAllowed.superResult[0] || resultNumber > valuesAllowed.superResult[1])){
      setResultError((prev) => ({
        ...prev,
        [name]: `El super número debe tener un valor entre ${processResult(valuesAllowed.superResult[0])} y ${processResult(valuesAllowed.superResult[1])}`,
      }));
    }else{
      setResultError((prev) => {
        const { [name]: _, ...everything } = prev;
        return everything;
      });
    }

    setSuperResult((prev) => processResult(prev));
  };

  const handleResultPaste = (e) => {
    const pasteValue = e.clipboardData.getData('text');
    const cleanValue = pasteValue.replace(/\s+/g, '');
    let resultNumbers = cleanValue.split('-');
    if(resultNumbers.length < 2){
      resultNumbers = resultNumbers[0].split('');
    }
    let resultIndex = 0;
    for(const name in results){
      const index = resultIndex;
      setResults((prev) => ({
        ...prev,
        [name]: resultNumbers[index] ? processResult(resultNumbers[index]) : '',
      }));
      resultIndex++;
    }
    if(formInfo.superResult && resultNumbers.length > 5){
      setSuperResult((prev) => processResult(resultNumbers[5]));
    }
  };
  
  return (
    <form onSubmit={handleSubmit} className="mb-4">
      <fieldset>
        <div className="mb-4 row">
          <div className="col-md-12 col-12">
            <div className="card">
              <div className="card-header">
                <a href={`/admin/${normalizeString(formInfo?.name)}`}><strong>{formInfo?.name}</strong></a>
              </div>
              <div className="card-body">
                {formInfo?.serial ? <div className="form-group mb-3">
                  <label className="form-label">Número del sorteo</label>
                  <input
                    type="text"
                    value={serial}
                    maxLength="4"
                    inputMode="numeric"
                    name={`Numero del Sorteo ${formInfo?.name}`}
                    placeholder="0000"
                    className="form-control"
                    onChange={handleSerialChange}
                    style={{ fontSize: '13px' }}
                    required
                    disabled={blockOnsend}
                  />
                </div> : ''}
                <div className="form-group mb-3">
                  <label className="form-label">Resultados del sorteo</label>
                  <div className="input-group">
                    {formInfo?.result?.map((_, index) => (<React.Fragment key={index}>{index !== 0 ? <span className="input-group-text" aria-hidden="true">-</span> : ''}
                      <input 
                        type="text"
                        value={results[`Resultado Balota ${index}`] || ''}
                        maxLength={formInfo?.colors ? "1" : "2"} 
                        inputMode="numeric" 
                        name={`Resultado Balota ${index}`}
                        onChange={handleResultChange}
                        onBlur={handleResultBlur}
                        onPaste={handleResultPaste}
                        className={`form-control text-center ${resultError[`Resultado Balota ${index}`] ? 'is-invalid' : ''}`}
                        placeholder={formInfo?.colors ? "1" : "01"}
                        aria-label={`${order[index]} balota"`}
                        style={{ fontSize: '13px', width: '70px', height: 'auto' }}
                        required 
                        disabled={blockOnsend}/>
                    </React.Fragment>))}
                    {formInfo?.superResult ? <><span className="input-group-text" aria-hidden="true">-</span>
                      <input 
                        type="text"
                        value={superResult}
                        maxLength="2" 
                        inputMode="numeric" 
                        name={`Resultado Super Balota`}
                        onChange={handleSuperResultChange}
                        onBlur={handleSuperResultBlur}
                        className={`form-control text-center ${resultError['Resultado Super Balota'] ? 'is-invalid' : ''}`}
                        placeholder="01"
                        aria-label={`super balota"`}
                        style={{
                          fontSize: '13px', width: '70px', height: 'auto', borderColor: '#dc3545',
                          boxShadow: '0 0 0 0.2rem rgba(220, 53, 69, 0.25)'
                        }}
                        required 
                        disabled={blockOnsend}/></> : ''}
                    <div className="invalid-feedback">{Object.values(resultError)[0]}</div>
                  </div>
                  <div className="input-group">
                    {formInfo?.colors?.map((_, index) => (<React.Fragment key={index}>{index !== 0 ? <span className="input-group-text" aria-hidden="true">-</span> : ''}
                    <select
                      name={`Color balota ${index}`}
                      className="form-select"
                      style={{ fontSize: '13px', width: '70px' }}
                      required
                      disabled={blockOnsend}
                    >
                      <option value="red">🔴 Rojo</option>
                      <option value="green">🟢 Verde</option>
                      <option value="blue">🔵 Azul</option>
                      <option value="yellow">🟡 Amarillo</option>
                      <option value="black">⚫ Negro</option>
                      <option value="white">⚪ Blanco</option>
                    </select>
                    </React.Fragment>))}
                  </div>
                </div>

                <div className="form-group mb-3">
                  <label className="form-label">Fecha del sorteo</label>
                  <input
                    type="date"
                    name={`Fecha del sorteo ${formInfo?.name}`}
                    className="form-control"
                    defaultValue={actualDate}
                    style={{ fontSize: '13px' }}
                    required
                    disabled={blockOnsend}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </fieldset>

      <button type="submit" className="btn btn-primary" disabled={loading || blockOnsend}>
        {loading ? 'Añadiendo...' : blockOnsend ? 'Enviado correctamente' : 'Enviar'}
      </button>
    </form>
  );
};